import _ from 'lodash'

export const getCandidateStruDataList = list => {
  const productStructuredDataList = _.get(list, 'productStructuredDataList')

  const uniqueProductSkuStruDataList = _.uniqBy(productStructuredDataList, 'sku')
  const candidateStruDataList = _.uniqBy(uniqueProductSkuStruDataList, 'struDataAttrClusterId')

  return candidateStruDataList
}

const transformModelSpec = modelOrItem => {
  const spec = _.get(modelOrItem, 'spec', {})
  const {
    name = '',
    selectedValue = ''
  } = spec

  return {
    ...modelOrItem,
    displayName: selectedValue,
    spec: {
      name,
      values: [selectedValue]
    }
  }
}

const transformModelItemSpec = model => {
  const modelItems = _.get(model, 'items', null)
  const hasModelItems = !_.isNull(modelItems)
  return hasModelItems
    ? {
      ...model,
      items: modelItems.map(transformModelSpec)
    }
    : model
}

export const getModelsForUpdateAttr = models => models
  .map(transformModelSpec)
  .map(transformModelItemSpec)

export const getOuterSpecs = models => {
  const specs = []

  const _getModelSpecNameFrom = model => _.get(model, 'spec.name')

  // 即使是無屬性時也會手動硬塞一個只有 sku 的 model 在其他地方使用
  // 因此要用 model 裡其他欄位判斷是否需要組出 specs
  // ex: [{ sku: 123, images: undefined, videos: undefined }]
  const firstModel = _.get(models, '[0]')
  const isFirstModelExist = !_.isEmpty(_getModelSpecNameFrom(firstModel))
  if (isFirstModelExist) {
    specs.push({
      level: 1,
      name: _getModelSpecNameFrom(firstModel)
    })

    const firstModelItem = _.get(firstModel, 'items[0]')
    if (firstModelItem) {
      specs.push({
        level: 2,
        name: _getModelSpecNameFrom(firstModelItem)
      })
    }
  }

  return specs
}
